const selectMenu = (Simplebar) => {
    const menu = document.querySelectorAll(".select-menu");
    if (menu.length) {
        for (let i = 0; i < menu.length; i++) {
            const menuItem = menu[i];
            const selected = menuItem.querySelector(".select-menu__selected");
            const list = menuItem.querySelector(".select-menu__list");
            selected.addEventListener("click", function(){
                menuItem.classList.toggle("open");
            });
            list.addEventListener("click", function(e){
                if (e.target.href) {
                    selected.querySelector(".select-menu__selected-text").innerText = e.target.innerText;
                    menuItem.classList.remove("open");
                }
            });
            new Simplebar(list, {
               autoHide: false,
            });
        }
    }
}
export default selectMenu;
